import { atom } from "recoil";
import { IOption } from "../types/CommonTypes";
import { ITag } from "../types/TagTypes";
import { FormNameType } from "./../generated/Api";

export interface INewForm {
  description: string;
  name: string;
  nameType: FormNameType;
  formTagId: string;
  selectedTags: ITag[];
  selectedUserOption: IOption;
  selectedUsers: IOption[];
  url: string;

  validate?: {
    autoCapitalizeName: boolean;
    preventSmallNames: boolean;
    validatePhone: boolean;
  };
}

export const NewFormAtom = atom<INewForm>({
  key: "NewFormAtom",
  default: {
    description: "",
    name: "",
    nameType: FormNameType.NO_NAME,
    formTagId: "",
    selectedTags: [],
    selectedUserOption: {
      value: "",
      name: "",
    },
    selectedUsers: [],
    url: "",

    validate: {
      autoCapitalizeName: false,
      preventSmallNames: false,
      validatePhone: false,
    },
  },
});
